import React, { type ReactNode } from 'react';
import noop from 'lodash/noop';
import Link from '@atlaskit/link';
import { fg } from '@atlassian/jira-feature-gating';

type Props = {
	enabled?: boolean;
	href: string;
	children: ReactNode;
	onClick?: () => void;
};

/**
 * @deprecated Use `@atlaskit/link` instead.
 */
export const ExternalLink = ({ enabled = true, href, children = null, onClick = noop }: Props) => {
	if (fg('jsm_gs_a11y_fixes_p1')) {
		return enabled ? (
			<Link rel="noreferrer" href={href} target="_blank" onClick={onClick}>
				{children}
			</Link>
		) : (
			<>{children}</>
		);
	}

	return enabled ? (
		<a rel="noreferrer" href={href} target="_blank" onClick={onClick}>
			{children}
		</a>
	) : (
		<>{children}</>
	);
};
